/**
 * Created by Viacheslav Stepanian on 24.02.2026.
 */

const StagesQuestRow = function (row) {
    return Prefab.instantiate(bundles.quests_window.jsons.stages_quest_row_prefab_json, { row });
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    STAGESQUESTROW_TITLE: {
        name: "nostroke",
        color: new cc.Color(168, 66, 38),
        size: 50
    }
});